import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BlockedContentService } from '../../../services/blocked-content.service';

@Component({
  selector: 'nr-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  public links;

  constructor(private blockedContentService: BlockedContentService) {
    this.links = environment.footerLinks;
  }

  onLinkClick(link: string) {
    const newWin = window.open(link);
    this.blockedContentService.showWarningMessage(newWin);
  }
}
